import { useCurrentUserPlusMembership } from '~/domains/auth/queries';

import {
  PLUS_MEMBERSHIP_BONUSPACK_JOIN_URL,
  PLUS_MEMBERSHIP_FREE_TRIAL_JOIN_URL,
  PLUS_MEMBERSHIP_STANDARD_JOIN_URL,
} from '../constants';

/**
 * @description 플멤 상태
 * @returns {boolean} isTrialAvailable - 무료체험 가능 여부
 * @returns {boolean} isAvailableToSubscribe - 구독 가능 여부
 * @returns {boolean} isMembershipStandard - 스탠다드 가입 여부
 * @returns {boolean} isAvailableToSubscribeBonusPack - 보너스팩 구독 가능 여부
 * @returns {boolean} isMembershipSubscribeServiceAvailable - 구독에서 제공하는 서비스들 중 하나라도 가입 가능 여부
 * @returns {boolean} isBonusPackRegistered - 보너스팩 가입 여부
 * @returns {function} getRegisterMembershipUrl - 멤버십 가입 URL 반환
 * */
export const useMembershipStatus = () => {
  const { data: membershipData } = useCurrentUserPlusMembership();

  const isTrialAvailable = membershipData?.isTrialAvailable;

  const isAvailableToSubscribe =
    membershipData?.isAvailableToSubscribe ||
    (!membershipData?.isTrialAvailable &&
      membershipData?.isAvailableToSubscribe);

  const isAvailableToSubscribeBonusPack =
    membershipData?.registerableMembershipOptionLuckyBonusPack;

  const isMembershipStandard =
    membershipData?.planDetail?.planGrade === 'STANDARD';

  const isMembershipSubscribeServiceAvailable =
    membershipData?.isTrialAvailable ||
    membershipData?.isAvailableToSubscribe ||
    membershipData?.registerableMembershipOptionLuckyBonusPack;

  const getRegisterMembershipUrl = (actionAfterSuccess = false) => {
    const redirectAfterSuccess = actionAfterSuccess
      ? '&actionAfterSuccess=quit'
      : '';

    if (isTrialAvailable) {
      return `${PLUS_MEMBERSHIP_FREE_TRIAL_JOIN_URL}${redirectAfterSuccess}`;
    }

    if (isAvailableToSubscribe) {
      return `${PLUS_MEMBERSHIP_STANDARD_JOIN_URL}${redirectAfterSuccess}`;
    }

    if (isAvailableToSubscribeBonusPack) {
      return `${PLUS_MEMBERSHIP_BONUSPACK_JOIN_URL}${redirectAfterSuccess}`;
    }
    return '';
  };

  return {
    planDetail: membershipData?.planDetail,
    isTrialAvailable,
    isAvailableToSubscribe,
    isMembershipStandard,
    isAvailableToSubscribeBonusPack,
    isMembershipSubscribeServiceAvailable,
    isBonusPackRegistered: membershipData?.isBonusPack,
    getRegisterMembershipUrl,
  };
};
